require('./fontCut')
require('./money')
require('./format')
require('./copy')
require('./hightLight')
